module.exports = __webpack_public_path__ + "img/product_shiseido_2.99661164.png";